import { Link } from "react-router-dom";
import PageHero from "@/components/PageHero";

export default function About() {
  return (
    <>
      <PageHero
        eyebrow="About"
        title="Anant Jeevan — Eternal life in Jesus Christ."
        subtitle="An independent Christian teaching platform. We are not a church, a denomination, or a political organisation. We are Christ-centred, Scripture-rooted, and gracious in tone."
      />
      <section className="py-16 sm:py-24">
        <div className="container-reading prose-editorial">
          <h2>Our purpose</h2>
          <p>
            Anant Jeevan exists to help people explore the Bible, understand the Gospel, know Jesus Christ, and
            discover the eternal life God offers through Him. We serve seekers, new believers, growing Christians,
            parents, children, and Bible students — in English and, over time, in Hindi and several regional Indian
            languages.
          </p>

          <h2>How we work</h2>
          <p>
            Every article passes through a workflow: author draft → editorial review → theological review →
            translation review → approval → scheduled or published. We treat Scripture seriously, and we treat our
            readers as fellow image-bearers of God.
          </p>

          <h2>Editorial standards</h2>
          <p>
            We identify the primary Scripture behind each article, explain its context, distinguish observation from
            interpretation and application, and use supporting passages responsibly. We do not proof-text. We name
            secondary matters as secondary. We correct errors visibly.
          </p>

          <h2>Bible translations and copyright</h2>
          <p>
            KJV is public domain and is displayed in full. NKJV, ESV, and NIV are licensed translations — we display
            only short, permitted excerpts with attribution until fuller licensing is configured, and we link readers
            to authorised Bible providers for the complete text.
          </p>

          <h2>Child safety</h2>
          <p>
            The Kids &amp; Families section has no public comments, no child-to-adult messaging, no unnecessary data
            collection, and no frightening imagery. Any contact regarding a child must go through a parent or
            guardian.
          </p>

          <h2>Respectful communication</h2>
          <p>
            We welcome readers from every religious and social background. We may disagree with other religions
            theologically, but we will never insult or mock people. We aim to persuade with the truth of Scripture,
            in the manner of Christ.
          </p>

          <div className="mt-12 flex flex-wrap gap-3">
            <Link to="/what-we-believe" className="btn-primary">Our Statement of Faith</Link>
            <Link to="/legal/editorial-standards" className="btn-ghost">Editorial Standards</Link>
            <Link to="/contact" className="btn-ghost">Contact Us</Link>
          </div>
        </div>
      </section>
    </>
  );
}
